import React, { useState } from 'react';

const Fact = ({ fact }) => (
  <div>
    <b className={fact.tone}>
      {fact.value.map((segment, index) => (
        <React.Fragment key={`${segment.text}-${index}`}>
          {index > 0 ? ' ' : null}
          {segment.tone ? <span className={segment.tone}>{segment.text}</span> : segment.text}
        </React.Fragment>
      ))}
    </b>
    <span>{fact.label}</span>
  </div>
);

const Detail = ({ label, text }) => {
  if (!text) return null;
  const lines = String(text).split('\n');
  return (
    <p className="lead">
      <b>{label}. </b>
      {lines.map((line, index) => (
        <React.Fragment key={`${index}-${line}`}>
          {index > 0 ? <br /> : null}
          {line}
        </React.Fragment>
      ))}
    </p>
  );
};

/** One P1 Critical incident: facts, then description, cause notes, and close notes when ServiceNow has them. */
const IncidentSummary = ({ incident }) => (
  <div className="inc-summary">
    <div className="inc-facts">
      {(incident.facts || []).map((fact) => <Fact fact={fact} key={fact.label} />)}
    </div>
    <Detail label="Description" text={incident.description} />
    <Detail label="Cause notes" text={incident.causeNotes} />
    <Detail label="Close notes" text={incident.closeNotes} />
  </div>
);

/** P1 Critical ServiceNow incidents for this customer. Summary only. */
export default function IncidentsView({ incidents, incidentsLoading }) {
  const list = Array.isArray(incidents) ? incidents : [];
  const [selected, setSelected] = useState(list[0] ? list[0].id : null);
  const incident = list.find((item) => item.id === selected) || list[0];
  if (!incident) {
    return (
      <section>
        <p className="note">
          {incidentsLoading
            ? 'Incidents are being loaded, check again shortly.'
            : 'No P1 Critical incidents for this customer in this period.'}
        </p>
      </section>
    );
  }
  return (
    <section>
      <div className="inc-list" role="tablist" aria-label="Incidents">
        {list.map((item) => (
          <button
            type="button"
            role="tab"
            className="inc-item"
            key={item.id}
            aria-selected={item.id === incident.id ? 'true' : 'false'}
            onClick={() => setSelected(item.id)}
          >
            <b>{item.title}</b>
            <span>{item.meta}</span>
          </button>
        ))}
      </div>
      <h2>Summary</h2>
      <IncidentSummary incident={incident} />
    </section>
  );
}
